import React, { useEffect } from "react";
import PropTypes from "prop-types";
import t from "../../../utils/common/translation/translator";

const SncWidget = ({ onOutput, kbType, presetValues }) => {
  const openSncWidget = () => {
    var dataset_stepper = {
      type: "kb", // technology of the selector
      value: "KB_GCR_LXM38IS" // name of the selector
    };

    var dataset_servo = {
      type: "kb", // technology of the selector
      value: "KB_GCR_LXM38IA" // name of the selector
    };

    const dataset = kbType === "STEPPER" ? dataset_stepper : dataset_servo;

    var language = "EN";
    var country = "SCHINT";
    var project = "ANY";

    var token = "Bearer qsfqsdqsd";

    var widgetOptions = {
      apiEndpoint: "https://selectconfig-data.schneider-electric.com",
      buttons: {
        saveConfiguration: {
          title: t("integrated_drives.ui.continue_to_configuration"), // change the button label
          isVisible: true // hide the button "add to cart"
        }
      },

      advancedConfiguration: {
        selectorConfiguration: [
          {
            selector: dataset.value,
            characteristics: {
              preset: presetValues
            }
          }
        ]
      }
      // enableNameConfiguration: true
    };

    // eslint-disable-next-line no-undef
    var wrapperInstance = seWidgetWrapper.startWidget(dataset, language, country, project, token, widgetOptions);

    wrapperInstance.addSaveConfigurationListener(function (event) {
      console.info("-------------------------------");
      console.info("onSaveConfiguration");
      console.info("Products:", event.products);
      console.info("Extras:", event.extras);
      console.info("-------------------------------");

      onOutput(event);
    });
  };

  useEffect(() => {
    openSncWidget();
  }, []);

  return <div id="widgetFrame" className="w-full h-full"></div>;
};

SncWidget.propTypes = {
  onOutput: PropTypes.func.isRequired,
  kbType: PropTypes.string.isRequired
};

export default SncWidget;
